import { BidderCatalog } from '@pubstack/common/src/bidderCatalog'
import { CatalogItem } from '@pubstack/common/src/catalogItem'
import { MarketplaceBidder } from '@pubstack/common/src/marketplaceBidder'
import { PrebidModuleCatalogEntry } from '@pubstack/common/src/prebidModule'
import { sortByName, sortByNameOf } from '@pubstack/common/src/sort'
import { sortByDisplayName } from '@pubstack/http/useCatalogs'
import { Product } from '~/hooks/useProduct'
import { buildUrlWithSearchParams } from '~/utils/url'
import { useQuery } from './api-client'

const CATALOG_QUERY_KEYS = ['catalog']

const modulesByDisplayName = sortByNameOf<CatalogItem>((module) => module.displayName)

//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------

export type useCatalogOptions = { isPbstckBidderCompatible?: boolean }

export const useCatalog = (product: Product, { isPbstckBidderCompatible }: useCatalogOptions = {}, enabled = true) => {
  const url = buildUrlWithSearchParams(`/${product}/catalog`, {
    isPbstckBidderCompatible: isPbstckBidderCompatible ? 'true' : undefined,
  })
  const queryResult = useQuery<BidderCatalog[]>({ url, keys: [product, ...CATALOG_QUERY_KEYS, { isPbstckBidderCompatible }], enabled, select: sortByDisplayName })

  return { ...queryResult, data: queryResult.data || [] }
}

export const useCatalogBidder = (product: Product, bidderId?: string) => {
  return useQuery<BidderCatalog>({ url: `/${product}/catalog/${bidderId}`, keys: [product, ...CATALOG_QUERY_KEYS, 'bidder', bidderId || ''], enabled: !!bidderId })
}

export const useCatalogModules = () => {
  const queryResult = useQuery<CatalogItem[]>({ url: `/adm/catalog/modules`, keys: ['adm', ...CATALOG_QUERY_KEYS, 'modules'], select: modulesByDisplayName })

  return { ...queryResult, data: queryResult.data || [] }
}

export const usePrebidModulesCatalog = () => {
  const queryResult = useQuery<PrebidModuleCatalogEntry[]>({ url: `/adm/catalog/module-definitions`, keys: ['adm', ...CATALOG_QUERY_KEYS, 'module-definitions'] })
  const modules = queryResult.data || []
  const byId = Object.fromEntries(modules.map((module) => [module.id, module])) as Record<string, PrebidModuleCatalogEntry>

  return { ...queryResult, modules, byId }
}

export const useMarketplaceBiddders = (enabled = true) => {
  const queryResult = useQuery<MarketplaceBidder[]>({ url: '/marketplace/integration', keys: ['marketplace', 'integration'], enabled, select: sortByName })

  return { ...queryResult, data: queryResult.data || [] }
}
